// extracted by mini-css-extract-plugin
module.exports = {"gallery-tile":"GalleryTile_gallery-tile__9OSnD","back":"GalleryTile_back__9HRFs","top":"GalleryTile_top__JEaiF"};